import {
    USUARI_INICIALITZAR,
    USUARI_OBTENIR_ROLS_EN_CURS,
    USUARI_OBTENIR_ROLS_FINALITZADA
} from '../../actions/actionTypes';

const ESTAT_INICIAL = false;

const peticioRolsEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_OBTENIR_ROLS_EN_CURS:
            return true;

        case USUARI_OBTENIR_ROLS_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioRolsEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/usuari/peticioRolsEnCurs.js